import React from 'react'
import UserPage from '../../common/UserPage/UserPage'
import Footer from '../../common/Footer/Footer'
import TherapyPlanner from '../../components/UserTherapyPlanner/TherapyPlanner'
import { useSelector } from 'react-redux'

function UserTherapyPlannerPage() {
  const { currentUser } = useSelector((state) => state.users);
  
  return (
    <div>
        <UserPage customImage={currentUser?.picture} />
        <TherapyPlanner />
        <Footer />
    </div>
  )
}

export default UserTherapyPlannerPage